module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp13_3.3a0f4ee9.png";